import { render, staticRenderFns } from "./ChannelLine.vue?vue&type=template&id=52386ed8"
import script from "./ChannelLine.vue?vue&type=script&lang=js"
export * from "./ChannelLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports